export const iconFontAwesomeFilesScissors = (
	<i className="fa-solid fa-scissors"></i>
);
